import { useState, useCallback } from 'react';
import { useLazyQuery } from '@apollo/client';
import gql from 'graphql-tag';

const FIND_USER_QUERY = gql`
    query getUser($email: String, $phone: String, $role: UserRole) {
        user(email: $email, phone: $phone, role: $role) {
            id
            ... on Master {
                ...userFields
            }
            ... on Client {
                ...userFields
            }
            ... on Administrator {
                ...userFields
            }
            ... on Supplier {
                ...userFields
            }
        }
    }

    fragment userFields on User {
        email
        firstName
        lastName
        phone
        gender
    }
`;

export default function useUserLookup() {
    const [findUser, { data, loading }] = useLazyQuery(FIND_USER_QUERY, {
        fetchPolicy: 'network-only',
    });
    const [visible, setVisible] = useState(false);

    const userLookupStatus = !visible ? null : loading ? 'CHECKING' : data?.user ? 'EXISTS' : null;
    const userLookupUser = visible ? (data?.user || null) : null;

    const onUserLookup = useCallback(({ email, phone, role }) => {
        setVisible(true);
        findUser({ variables: { email, phone, role } });
    }, [findUser]);

    const resetUserLookup = useCallback(() => {
        setVisible(false);
    }, []);

    return { userLookupStatus, userLookupUser, onUserLookup, resetUserLookup };
}
